import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  Inject,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-livechat-widget',
  templateUrl: './livechat-widget.component.html',
  styleUrls: ['./livechat-widget.component.css']
})
export class LivechatWidgetComponent implements OnInit, OnDestroy {
  initScriptEl: HTMLScriptElement | null = null;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.loadWidget();
  }

  ngOnDestroy(): void {
    this.removeWidget();
  }

  loadWidget(): void {
    this.initScriptEl = this.renderer.createElement('script') as HTMLScriptElement;
    this.initScriptEl.type = 'text/javascript';
    this.initScriptEl.text = `
      window.__lc = window.__lc || {};
      window.__lc.license = 10826272;
      window.__lc.group = 148;
      (function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
    `;

    this.renderer.appendChild(this.document.head, this.initScriptEl);
  }

  removeWidget(): void {
    if (this.initScriptEl) {
      this.renderer.removeChild(this.document.head, this.initScriptEl);
      this.initScriptEl = null;
    }

    const trackingScript = this.document.querySelector(
      'script[src="https://cdn.livechatinc.com/tracking.js"]'
    );
    if (trackingScript) {
      trackingScript.remove();
    }

    const widgetContainer = this.document.getElementById('chat-widget-container');
    if (widgetContainer) {
      widgetContainer.remove();
    }

    (window as any).__lc = undefined;
    (window as any).LiveChatWidget = undefined;
  }
}
